import {Col, Container, Form, Row} from "react-bootstrap";
import React, {useContext, useEffect, useState} from "react";
import useWindowDimensions from "hooks/Dimensions";
import {ActionPanelContext} from "context/action";
import {API_CALL_ERR_MSG} from "utils/ConstantsMsg";
import {ToastContext} from "context/Toast";

export default function WireApproveModal(props) {

    const {setShowApprove, setShow, gridApi} = props
    const {isDesktop, isMobile} = useWindowDimensions();
    const {handleApprove, isValidApprover} = useContext(ActionPanelContext);
    const [comment, setComment] = useState('');
    const [approving, setApproving] = useState(false);
    const {error, success, alert} = useContext(ToastContext);


    const handleOnChange = (param) => {
        setComment(param.target.value)
    }

    const handleOnApproveClicked = () => {

        if(gridApi.getSelectedRows().length === 0){
            alert("Select an item to approve")
            setApproving(true)
            return
        }

        const onSuccess = () => {
            setApproving(false);
            setShow(false);
            setApproving(false)
            success("Item/s approved successfully")

        }

        const onError = (err) => {
            console.log("Error", err.response.data)
            let errMsg = API_CALL_ERR_MSG
            if (err.response.status === 409)
                errMsg = err.response.data
            error(errMsg)

            setShow(true);
            setShowApprove(true);
            setApproving(true)
        }


        handleApprove(comment, onSuccess, onError);
    }

    const getRestrictedItems = () => {
        return gridApi.getSelectedRows().filter(row => !row.isValidApprover).map((row, i) => getRowData(row, i))
    }

    const getRowData = (row, i) => {
        return(<>
            <span>{i+1}) Template:{row.templateName}, Manager:{row.managerNameShort}, Account:{row.cdClient}, Status:{row.status} </span><br/>
        </>)
    }

    return (<>
        {!isValidApprover ?
            <Container fluid className={"my-3 my-md-0"}>
                <Row>
                    <Col md={12}>
                        <h4 style={{textAlign: isDesktop?'left':'center'}}>The following items cannot be approved:</h4>
                    </Col>
                    <Col>
                        {getRestrictedItems()}
                    </Col>
                </Row>
            </Container>
        :
        <Container fluid className={"my-3 my-md-0"}>

            <Row>
                <Col md={12}>
                    <h4 style={{textAlign: isDesktop?'left':'center'}}>Are you sure you want to approve this?</h4><br/>
                </Col>
            </Row>
            <Row>
                <Col md={12} className='pb-2'>
                    <Form.Label className="filter-input-label pb-2">Add Comments</Form.Label>
                    <Form.Group controlId="comment">
                        <Form.Control as='textarea' rows={5} placeholder="Leave a comment" disabled={approving}
                                      name={"comment"} value={comment}
                                      onChange={handleOnChange}/>
                    </Form.Group>
                </Col>
            </Row>
            <Row className={"justify-content-end"}>
                <Col md={4} xs={12} sm={12}>
                    <button disabled={approving} className={'btn btn-block td-btn-primary-light'} href="#" onClick={handleOnApproveClicked}>Approve
                    </button>
                </Col>
                <Col md={4} xs={12} sm={12} className='md-pr-0 d-md-block'>
                    <button disabled={approving} className='btn btn-block td-btn-secondary-clear' href="#" onClick={() => {
                        setShow(false);
                        setShowApprove(false);
                    }}>Cancel
                    </button>
                </Col>
            </Row>
        </Container> }
    </>)
}
